module.exports = __webpack_public_path__ + "img/manyPay1.28695c2d.png";